const RightSide = () => {
  return (
    <div className="right-side icon-right-success">
      <i className="fa fa-shopping-basket">
        <div className="shap-block">
          <div className="rounded-shap animate-bg-secondary">
            <i></i>
            <i></i>
          </div>
        </div>
      </i>
    </div>
  );
};

export default RightSide;
